import { API_ENDPOINTS } from "@features/creation/config/constants";
import UniversCommercialViewPage from "@features/creation/univers-commerciaux/components/UniversCommercialViewPage";
import api from "@lib/api";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Layers } from "lucide-react";

export const Route = createFileRoute("/_app/creation/univers-commerciaux/$id/view")({
  loader: async (ctx) => {
    await requirePermission(PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.VIEW)(ctx);
    const { data } = await api.get(API_ENDPOINTS.UNIVERS_COMMERCIAUX.DETAIL(ctx.params.id));
    return data;
  },
  staticData: {
    title: "Détails univers",
    icon: Layers,
    permission: PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.VIEW,
    section: "Creation",
    order: 15,
    showInBreadcrumb: true,
  },
  component: ViewUniversCommercialPage,
});

function ViewUniversCommercialPage() {
  const universCommercial = Route.useLoaderData();

  return <UniversCommercialViewPage universCommercial={universCommercial} />;
}
